export const AUTH_BUTTON_LABELS = {
  signIn: 'Sign In with Microsoft',
  redirecting: 'Redirecting to Microsoft...'
} as const;
